<div class="brick">
  <div class="connector" [style.background-color]="colour"></div>
  <div class="connector" [style.background-color]="colour"></div>
  <div class="connector" [style.background-color]="colour"></div>
  <div class="connector" [style.background-color]="colour"></div>
  <div class="body" [style.background-color]="colour"></div>
</div>
<p class="colour-code">{{ name }}</p>
